(() => {
  function parseBoxSizeFromTitle(title) {
    // expects variant titles containing a number like "Box of 4"
    const m = String(title).match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  function initPicker(picker) {
    const form =
      picker.closest('form[action^="/cart/add"]') ||
      picker.closest('product-form')?.querySelector('form[action^="/cart/add"]');

    if (!form) return;

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    const addBtn = form.querySelector('button[name="add"], button[type="submit"]');
    const paymentBtn = form.querySelector('.shopify-payment-button__button');

    const errorEl = picker.querySelector('.flavor-picker__error');
    const selectedEl = picker.querySelector('[data-selected]');
    const maxEl = picker.querySelector('[data-max]');

    const slots = Array.from(picker.querySelectorAll('.flavor-picker__slot'));
    const selects = slots.map(slot => slot.querySelector('select'));

    const variants = JSON.parse(
      picker.querySelector('script[data-variant-titles]')?.textContent || '[]'
    );

    function getVariantTitle() {
      const id = Number(variantInput.value);
      return variants.find(v => Number(v.id) === id)?.title || '';
    }

    function requiredCount() {
      return parseBoxSizeFromTitle(getVariantTitle());
    }

    function setButtonsEnabled(enabled) {
      if (addBtn) addBtn.disabled = !enabled;
      if (paymentBtn) paymentBtn.disabled = !enabled;
    }

    function clearHiddenSlots(fromIndex) {
      for (let i = fromIndex; i < slots.length; i++) {
        selects[i].value = '';
      }
    }

    function validate(showError = false) {
      const required = Number(maxEl.textContent) || 0;
      const visibleSelects = selects.filter((_, idx) => idx < required);
      const filled = visibleSelects.filter(s => (s.value || '').trim() !== '').length;

      selectedEl.textContent = String(filled);

      const ok = required > 0 && filled === required;

      if (!ok) {
        setButtonsEnabled(false);
        if (showError) {
          errorEl.textContent = `Please select all ${required} flavors before adding to cart.`;
          errorEl.hidden = false;
        } else {
          errorEl.hidden = true;
        }
      } else {
        errorEl.hidden = true;
        setButtonsEnabled(true);
      }

      return ok;
    }

    function updateUI() {
      const req = requiredCount();
      maxEl.textContent = String(req);

      slots.forEach((slot, idx) => {
        slot.style.display = idx < req ? '' : 'none';
      });

      clearHiddenSlots(req);
      validate(false);
    }

    picker.addEventListener('change', (e) => {
      if (e.target.tagName === 'SELECT') validate(false);
    });

    variantInput.addEventListener('change', updateUI);

    // In case theme updates variant without firing change
    new MutationObserver(updateUI).observe(variantInput, {
      attributes: true,
      attributeFilter: ['value'],
    });

    form.addEventListener('submit', (e) => {
      if (!validate(true)) {
        e.preventDefault();
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    updateUI();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.flavor-picker').forEach(initPicker);
  });
})();
